import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost:8000/api/v1",
  // baseURL: "https://lexpedia-api-up29-lg2asx94v-utkarshsiddharth.vercel.app/api/v1",
  // baseURL: "http://3.110.185.17:5000/api/v1",
  baseURL: "https://backend.lexpediagroup.xyz/api/v1",
  // baseURL: "http://13.200.120.142:8000/api/v1",
});
